import React, { useState } from "react";
import { Card, Col, Row } from "reactstrap";
import DynamicForm from "./DynamicForm";
import FilteredLeadsTable from "./FilteredLeadsTable";

function SegmentView() {
  const [dataView, setDataView] = useState([]);

  return (
    <div
      className="mb-4  ml-4"
      style={{ paddingLeft: "2%", paddingRight: "2%" }}
    >
      <Row>
        <Col xs={7}>
          <div>
            <DynamicForm onDataChange={setDataView} />
          </div>
        </Col>
        <Col xs={5}>
          <div className="dynamic-result">
            <span className="leads-filtrados-header">Leads Filtrados:</span>
            <Card style={{ marginTop: 10 }}>
              <div style={{ overflowX: "auto", minHeight: "70vh" }}>
                {dataView.length === 0 ? (
                  <div className="not-found-lead-div">
                    <span className="m-1">
                      Nenhum lead foi encontrado com essas condições.
                    </span>
                  </div>
                ) : null}
                <FilteredLeadsTable dataView={dataView} />
              </div>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default SegmentView;
